import { render, staticRenderFns } from "./offline_order.vue?vue&type=template&id=32b1d50a&scoped=true&"
import script from "./offline_order.vue?vue&type=script&lang=js&"
export * from "./offline_order.vue?vue&type=script&lang=js&"
import style0 from "./offline_order.vue?vue&type=style&index=0&id=32b1d50a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b1d50a",
  null
  
)

export default component.exports